module.exports = __webpack_public_path__ + "img/Symbol_H3.62900224.png";